import { Handle, Position } from 'reactflow';
import { BaseNode } from './BaseNode';

interface SwitchCase {
  id: string;
  value?: string;
}

export function SwitchNode({
  data,
}: {
  data: { label: string; alias?: string; expression?: string; cases?: SwitchCase[] };
}) {
  const cases = data.cases ?? [];
  const slots = cases.length + 1; // + default

  return (
    <BaseNode
      type="switch"
      label={data.label}
      alias={data.alias}
      hasSource={false}
      lines={[{ text: data.expression, mono: true }]}
      footer={`${cases.length} case${cases.length === 1 ? '' : 's'} + default`}
    >
      {cases.map((c, i) => (
        <Handle
          key={c.id}
          type="source"
          position={Position.Bottom}
          id={c.id}
          title={c.value || c.id}
          style={{ left: `${((i + 1) / (slots + 1)) * 100}%` }}
          className="!border-tone-amber"
        />
      ))}
      <Handle
        type="source"
        position={Position.Bottom}
        id="default"
        title="default (no match)"
        style={{ left: `${(slots / (slots + 1)) * 100}%` }}
      />
    </BaseNode>
  );
}
